class FormatService {
    constructor() {
        const toCurrency = (number) => {
            return number.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: '0'
            });
        };

        const toDelimited = (number) => {
            return number.toLocaleString('en-US', {
                style: 'decimal'
            });
        };

        this.format = (number, format) => {
            if (!isNaN(number)) {
                number = Number(number);
                if (format === 'delimited') {
                    return toDelimited(number);
                }
                else if (format === 'currency') {
                    return toCurrency(number);
                }
            }
            return number;
        };
    }
}

export default new FormatService();
